import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';
import useUserProfile from '@/api/userProfiles/useUserProfile.ts';

const IsAdmin: FC = () => {
  const { isLoading, session } = useAuthContext();
  const { data: userProfile, isLoading: isLoadingProfile, isFetching: isFetchingProfile } = useUserProfile(session?.user?.id);

  // Block the redirect while any fetch is in flight — stale cache can show a
  // stale role (e.g. after a role change), so we must wait for the fresh value.
  const loading = isLoading || (!!session && (isLoadingProfile || isFetchingProfile));

  if (!session && !isLoading) {
    return <Navigate to={Routes.LOGIN} />;
  }

  if (!loading && userProfile && userProfile.role !== 'admin') {
    return <Navigate to={Routes.DASHBOARD} />;
  }

  return <Middleware isLoading={loading}>{session ? <Outlet /> : null}</Middleware>;
};

export default IsAdmin;
